import { api } from "../api/Middleware";
import {
  USER_DEPARTMENTS_URL,
  USER_DEPARTMENTS_DETAIL_URL,
  USER_DEPARTMENTS_USERS_URL,
} from "../api/Urls";

// Service para gerenciar departamentos de usuários
class DepartmentServices {
  // Buscar departamentos com paginação e filtros
  async fetchDepartments(params = {}) {
    try {
      const response = await api.get(USER_DEPARTMENTS_URL, { params });

      // Se não há parâmetros de paginação, retornar apenas os resultados
      if (!params.page && !params.page_size) {
        return response.data.results || response.data || [];
      }

      // Retornar estrutura completa com paginação
      return {
        results: response.data.results || [],
        count: response.data.count || 0,
        total_pages: response.data.total_pages || 1,
        current_page: response.data.current_page || 1,
        page_size: response.data.page_size || 20,
        links: response.data.links || {},
      };
    } catch (error) {
      console.error("Erro ao carregar departamentos:", error);
      throw error;
    }
  }

  // Buscar departamentos simplificados (para dropdowns)
  async fetchDepartmentsSimple(isActive = true) {
    try {
      const params = { simple: true };
      if (isActive !== null) {
        params.is_active = isActive;
      }
      const response = await api.get(USER_DEPARTMENTS_URL, { params });
      // Garantir que sempre retorna um array
      const data = response.data;
      if (Array.isArray(data)) {
        return data;
      }
      if (data && Array.isArray(data.results)) {
        return data.results;
      }
      return [];
    } catch (error) {
      console.error("Erro ao carregar departamentos simplificados:", error);
      return [];
    }
  }

  // Buscar departamento por ID
  async fetchDepartmentById(id) {
    try {
      const response = await api.get(USER_DEPARTMENTS_DETAIL_URL(id));
      return response.data;
    } catch (error) {
      console.error("Erro ao carregar departamento:", error);
      throw error;
    }
  }

  // Salvar departamento (criar ou atualizar)
  async saveDepartment(data, editingId = null) {
    try {
      let response;
      if (editingId) {
        // Atualizar departamento existente
        response = await api.put(USER_DEPARTMENTS_DETAIL_URL(editingId), data);
      } else {
        // Criar novo departamento
        response = await api.post(USER_DEPARTMENTS_URL, data);
      }
      return response.data;
    } catch (error) {
      console.error("Erro ao salvar departamento:", error);
      throw error;
    }
  }

  // Remover departamento
  async deleteDepartment(id) {
    try {
      const response = await api.delete(USER_DEPARTMENTS_DETAIL_URL(id));
      return response.data;
    } catch (error) {
      console.error("Erro ao remover departamento:", error);
      throw error;
    }
  }

  // Alternar status ativo/inativo
  async toggleActiveStatus(id) {
    try {
      // Buscar departamento atual
      const department = await this.fetchDepartmentById(id);
      // Inverter status
      const response = await api.patch(USER_DEPARTMENTS_DETAIL_URL(id), {
        is_active: !department.is_active,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao alterar status:", error);
      throw error;
    }
  }

  // Buscar usuários de um departamento
  async fetchDepartmentUsers(departmentId) {
    try {
      const response = await api.get(USER_DEPARTMENTS_USERS_URL(departmentId));
      return response.data;
    } catch (error) {
      console.error("Erro ao carregar usuários do departamento:", error);
      throw error;
    }
  }
}

// Exportar instância única do service
const departmentServices = new DepartmentServices();
export default departmentServices;
